<template>
	<div class="row form-group">
		<div class="col-xs-12 col-md-8">
			<flCabecalhoForm :texto="_traducao('global', 'cicloTotaisManutencao')" />

			<div class="row">
				<div class="col-md-2 form-group col-xs-6">
					<label>{{ _traducao('global', 'vooInicial') }}:</label>
					<br />
					<p style="margin-bottom: 0px">
						{{ formulario.horimetro_inicial | horimetro }}
					</p>
				</div>

				<div class="col-md-2 form-group col-xs-6">
					<label>{{ _traducao('global', 'vooFinal') }}:</label>
					<br />
					<p style="margin-bottom: 0px">
						{{ formulario.horimetro_final | horimetro }}
					</p>
				</div>

				<div class="col-md-2 form-group col-xs-6">
					<label>{{ _traducao('global', 'totalDePartidas') }}:</label>
					<br />
					<p style="margin-bottom: 0px">
						{{
							Number(formulario.total_partidas) + Number(formulario.partidas)
						}}
					</p>
				</div>

				<div class="col-md-2 form-group col-xs-6">
					<label>{{ _traducao('global', 'totalDePousos') }}:</label>
					<br />
					<p style="margin-bottom: 0px">
						{{ Number(formulario.total_pousos) + Number(formulario.pousos) }}
					</p>
				</div>

				<div class="col-md-2 form-group col-xs-6" v-if="aeronave.tipo == 'H'">
					<label>{{ _traducao('global', 'totalDeGancho') }}:</label>
					<br />
					<p style="margin-bottom: 0px">
						{{ Number(formulario.total_gancho) + Number(formulario.gancho) }}
					</p>
				</div>

				<div class="col-md-2 form-group col-xs-6" v-if="aeronave.tipo == 'H'">
					<label>{{ _traducao('global', 'totalDeGuincho') }}:</label>
					<br />
					<p style="margin-bottom: 0px">
						{{ Number(formulario.total_guincho) + Number(formulario.guincho) }}
					</p>
				</div>
			</div>
		</div>

		<div class="col-xs-12 col-md-4">
			<flCabecalhoForm :texto="_traducao('global', 'ciclosTotaisMotor')" />

			<div class="row" v-if="formulario.trecho_motor.length > 0">
				<div class="col-xs-4">
					<label>Serial Number:</label>
				</div>

				<div class="col-xs-4">
					<label>{{ _traducao('global', 'totalDeCiclosNG') }}:</label>
				</div>

				<div class="col-xs-4">
					<label>{{ _traducao('global', 'totalDeCiclosNF') }}:</label>
				</div>
			</div>

			<div class="row" v-if="formulario.trecho_motor.length == 0">
				<div class="col-xs-12">N/A</div>
			</div>

			<div
				class="row"
				v-for="trechoMotor in formulario.trecho_motor"
				:key="'f' + trechoMotor.id"
			>
				<div class="col-xs-4" style="margin-bottom: 2px">
					{{ trechoMotor.serial_number }}
				</div>

				<div class="col-xs-4" style="margin-bottom: 2px">
					{{ Number(trechoMotor.total_ciclo_ng) | horimetro2 }}
				</div>

				<div class="col-xs-4" style="margin-bottom: 2px">
					{{ Number(trechoMotor.total_ciclo_nf) | horimetro2 }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'InformacoesCiclosTotais',

	props: {
		formulario: {
			type: Object,
			default: () => ({}),
			required: true
		},

		aeronave: {
			type: [Array, Object],
			default: [],
			required: false
		}
	}
}
</script>

<style></style>